import React, { useEffect, useState } from "react";
import { Formik, Form, Field } from "formik";
import { Row, Col, FormGroup } from "reactstrap";
import { Link } from "react-router-dom";
import INPUTS_CONST from "../../../constants/inputs";
import { loginSchema } from "../../../validationRules/login";
import { ErrorHelper, Input } from "../../atoms/input/Input";
import { focusAndScrollToError } from "../../../helpers/formHelper";
import Button from "../../atoms/button/Button";
import ROUTES from "../../../constants/routes";
import Anchor from "../../atoms/anchor/Anchor";
import GLOBAL_CONST from "../../../constants/global";
import { withRouter } from "react-router-dom";

const LoginForm = ({
  actions,
  error,
  isButtonDisable,
  type,
  history: { location },
  verifyData,
  resetVerify,
}) => {
  const formName = GLOBAL_CONST.LOGINFORM;
  const payload = location.search?.split("payload=")?.[1];
  const [preFieldEmail, setPreFieldEmail] = useState("");

  const handleFormSubmit = (values) => {
    actions.logIn(values, payload);
  };

  useEffect(() => {
    actions.clearError();
    return () => {
      setPreFieldEmail("");
      // resetVerify();
    };
  }, []);

  useEffect(() => {
    if (verifyData && verifyData.email) {
      setPreFieldEmail(verifyData.email);
      resetVerify();
    }
  }, [verifyData]);

  return (
    <Formik
      initialValues={{
        [INPUTS_CONST.email.name]: preFieldEmail ? preFieldEmail : "",
        [INPUTS_CONST.password.name]: "",
      }}
      validationSchema={loginSchema}
      onSubmit={handleFormSubmit}
      enableReinitialize
    >
      {(formik) => {
        const { values } = formik;
        return (
          <Form>
            {error && type === "Login" && <ErrorHelper>{error}</ErrorHelper>}
            <FormGroup>
              <Field
                type="email"
                hasIcon
                id={`${formName}-${INPUTS_CONST.email.name}`}
                name={INPUTS_CONST.email.name}
                labelProps={{
                  children: INPUTS_CONST.email.label,
                }}
                values={values[INPUTS_CONST.email.name]}
                component={Input}
                disabled={preFieldEmail}
              />
            </FormGroup>
            <FormGroup>
              <Field
                type="password"
                hasIcon
                id={`${formName}-${INPUTS_CONST.password.name}`}
                name={INPUTS_CONST.password.name}
                labelProps={{
                  children: INPUTS_CONST.password.label,
                }}
                component={Input}
              />
            </FormGroup>
            <Row>
              <Col md={6} className="mb-4">
                <Button
                  onClick={focusAndScrollToError}
                  id={`${formName}-page-log-in-btn`}
                  data-link-num={1000}
                  type="submit"
                  blue
                  block
                  disabled={isButtonDisable}
                >
                  Log in
                </Button>
              </Col>
              <Col md={6}>
                <Anchor
                  id={`${formName}-page-create-acct-link`}
                  tag={Link}
                  to={ROUTES.signup.route}
                  data-link-num={1001}
                  btn
                  blueOutline
                  href={"#"}
                >
                  Create account
                </Anchor>
              </Col>
            </Row>
          </Form>
        );
      }}
    </Formik>
  );
};

export default withRouter(LoginForm);
